<div class="d-flex flex-column align-items-stretch wrapper position-relative" #fileUploaderRef>
    <!-- Cabecera: label, icono y botón de añadir fichero -->
    <div class="d-flex justify-content-between align-items-center pb-3 mb-3 border-bottom" *ngIf="label || icon">
        <div class="d-flex align-items-center">
            <i class="icon {{icon}} me-2" *ngIf="icon"></i>
            <div *ngIf="label" class="color-greyish">{{label | translate}}</div>
        </div>
        <div class="d-flex align-items-center cursor-pointer z-2" *ngIf="!effectiveReadonly" (click)="onSelectFileClick()">
            <i class="icon icon-16-px-mas color-primary"></i>
            <span class="color-primary font-medium-large">{{'FILEUPLOADER.PLACEHOLDER' | translate}}</span>
        </div>
    </div>
    <!-- Listado de ficheros -->
    <div class="d-flex flex-column">
        <div *ngIf="files?.length > 0" class="file-box">
            <!-- Modo multiple: agrupado por fecha -->
            <ng-container *ngIf="multiple">
                <ng-container *ngFor="let group of groupedFiles">
                    <div class="section-lane">
                        <h4>{{group.label | translate}}</h4><hr>
                    </div>
                    <div class="d-flex justify-content-between align-items-center z-front w-100"
                        *ngFor="let fileData of group.files">
                        <div class="d-flex align-items-center w-100 mb-2">
                            <div class="me-auto w-50 d-flex align-items-center">
                                <span class="icon font-xxxlarge" [ngClass]="fileData.icon"></span>
                                <span class="font-large me-2 ellipsis-100" *ngIf="fileData.file?.name">{{fileData.file?.name}}</span>
                                <span class="font-large me-2 ellipsis-100" *ngIf="!fileData.file?.name">{{ fileData.file?.txtNam }}</span>
                                <span class="text-muted small">({{formatDate(fileData.date)}})</span>
                            </div>
                            <div class="ms-auto d-flex w-50">
                                <mapfre-auditlib-input *ngIf="showComment" [(model)]="fileData.file.comment"
                                    [placeholder]="'WORKS.CREATE.STEP2.FILE_PLACEHOLDER' | translate" styleClass="w-100">
                                </mapfre-auditlib-input>

                                <button class="ms-2 no-styles cursor-pointer ms-auto" *ngIf="!readonly"
                                    (click)="onDeleteClick(fileData.file)">
                                    <i *ngIf="isNewFile(fileData.file)" class="icon icon-16-px-cancelar"></i>
                                    <i *ngIf="!isNewFile(fileData.file)" class="icon icon-24-px-eliminar"></i>
                                </button>
                                <button class="ms-2 no-styles cursor-pointer" [ngClass]="{'ms-auto':readonly}"
                                    (click)="onDownloadClick(fileData.file)" *ngIf="!isNewFile(fileData.file)">
                                    <i class="icon icon-24-px-descarga font-xxxlarge cursor-pointer"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <!-- Modo single: sin agrupación ni fecha -->
            <ng-container *ngIf="!multiple">
                <div class="d-flex justify-content-between align-items-center z-front w-100">
                    <div class="d-flex align-items-center w-100 mb-2">
                        <div class="me-auto w-50 d-flex align-items-center">
                            <span class="icon font-xxxlarge" [ngClass]="getIcon(singleFile?.name || singleFile?.txtNam)"></span>
                            <span class="font-large me-2 ellipsis-100" *ngIf="singleFile?.name">{{singleFile.name}}</span>
                            <span class="font-large me-2 ellipsis-100" *ngIf="!singleFile?.name">{{ singleFile?.txtNam }}</span>
                        </div>
                        <div class="ms-auto d-flex w-50">
                            <mapfre-auditlib-input *ngIf="showComment" [(model)]="singleFile.comment"
                                [placeholder]="'WORKS.CREATE.STEP2.FILE_PLACEHOLDER' | translate" styleClass="w-100">
                            </mapfre-auditlib-input>

                            <button class="ms-2 no-styles cursor-pointer ms-auto" *ngIf="!readonly"
                                (click)="onDeleteClick(files[0])">
                                <i *ngIf="isNewFile(singleFile)" class="icon icon-16-px-cancelar"></i>
                                <i *ngIf="!isNewFile(singleFile)" class="icon icon-24-px-eliminar"></i>
                            </button>
                            <button class="ms-2 no-styles cursor-pointer" [ngClass]="{'ms-auto':readonly}"
                                (click)="onDownloadClick(files[0])" *ngIf="!isNewFile(singleFile)">
                                <i class="icon icon-24-px-descarga font-xxxlarge cursor-pointer"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <!-- Zona de arrastrar/subir fichero o mensaje de bloqueo -->
        <div class="drag-box" [class.drag-box-disabled]="effectiveReadonly" (click)="!effectiveReadonly && onSelectFileClick()">
          <i class="pi pi-ban me-2" *ngIf="effectiveReadonly"></i>
          <span>{{ (effectiveReadonly ? effectiveReadonlyMessage : 'FILEUPLOADER.PLACEHOLDER') | translate }}</span>
        </div>
    </div>
    <!-- Errores de validación del formulario -->
    <mapfre-auditlib-form-errors *ngIf="form" [form]="form" [targetRef]="fileUploaderRef"></mapfre-auditlib-form-errors>
    <!-- Inputs nativos de fichero (ocultos) -->
    <input type="file" (change)="onInputChange($event)" #inputFile *ngIf="!multiple" />
    <input type="file" (change)="onInputChange($event)" #inputFile *ngIf="multiple" multiple />
</div>
